import { useState } from "react";
import { getRequest } from "../../../../config";
import ReactTable from "react-table-6";
import "react-table-6/react-table.css"; // make sure styles are imported
import { useDispatch } from "react-redux";
import { toggleModal } from "../../../../reducers/modalReducer";
import moment from "moment";
import AdminCompanyDetailsModal from "../../../../components/modals/AdminCompanyDetailsModal/index";
import SubscriptionPaymentConfirm from "../../../../components/modals/SubscriptionPaymentConfirm/SubscriptionPaymentConfirm";

const SubscribedCompaniesTab = ({ isArchived, isYopmail, setDeleteCompany, handleRevenueLeadMode }) => {
    const [data, setData] = useState([]);
    const [pages, setPages] = useState(0); // total pages from backend
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState(""); // Add search term state
    const dispatch = useDispatch();
    const [plan, setPlan] = useState('Pro')
    const [selectedCompany, setSelectedCompany] = useState(null)


    let [companiesColumns] = useState([
        {
            id: 'cName',
            Header: 'Name',
            accessor: company => company['cName'] ? company['cName'] : '-',
        },
        {
            id: 'creatorId',
            Header: 'Owner',
            accessor: company => company['creatorId']?.['firstName'] ? company['creatorId']?.['firstName'] + " " + (company['creatorId']?.['lastName'] ? company['creatorId']?.['lastName'] : '') : '-',
        },
        {
            id: 'partnerId',
            Header: 'Partner',
            accessor: company => company['partnerId']?.['name'] ? company['partnerId']?.['name'] : '-',
        },
        {
            id: 'members',
            Header: 'Members',
            accessor: company => company['members']?.length > 0 ?
                company['members']?.map((obj, i, arr) => { return `${obj?.firstName ? obj?.firstName : ""} ${obj?.lastName ? obj?.lastName : ""}` }) : '-',
        },
        {
            id: 'createdAt',
            Header: 'Created At',
            accessor: company => company['createdAt'] ? moment(company['createdAt']).format('DD/MMM/YY') : '-',
        },
        {
            id: 'subscription',
            Header: 'Subscription',
            accessor: company => company['subscription'] ? company['subscription'] : '-',
        },
        {
            id: 'cType',
            Header: 'Type',
            accessor: company => company['cType'] ? company['cType'] : '-',
        },
        {
            id: 'cStage',
            Header: 'Stage',
            accessor: company => company['cStage'] ? company['cStage'] : '-',
        },
        {
            id: 'certificateNext',
            Header: 'Certification',
            accessor: company => company['certificateNext'] ? company['certificateNext'] : '-',
        },
        {
            id: 'paymentSource',
            Header: 'Source',
            accessor: company => {
                return company['isParent'] ? "In-Direct" : 'Direct'
            },
        },
        {
            id: 'testType',
            Header: 'Test Type',
            accessor: company => company['testType'] ? company['testType'] : '-',
        },
        {
            id: 'lastLogin',
            Header: 'Date Last Accessed',
            accessor: company => company['creatorId']?.['lastLogin'] ? moment(company['creatorId']?.['lastLogin']).format('DD/MMM/YY') : '-',
        },
        {
            id: 'action',
            Header: 'Revenue Lead',
            accessor: (company) => {
                return <input type="checkbox" checked={company?.revenueLeadMode ?? false} onChange={(e) => handleRevenueLeadMode(company, { revenueLeadMode: e.target.checked }, 'company')} />
            },
        },
        {
            id: 'view',
            Header: 'View',
            accessor: company => {
                const companyId = company._id || company.id;
                return (
                    <>
                        <button
                            onClick={() => {
                                dispatch(toggleModal({ open: 'AdminCompanyDetails' }))
                                setSelectedCompany(company)
                            }}
                            style={{
                                backgroundColor: "transparent",
                                border: "none",
                                cursor: "pointer"
                            }}
                        >
                            <i
                                data-tooltip="View Company Details"
                                className="fa fa-eye c4 cp"
                                style={{ fontSize: '20px' }}
                            />
                        </button>
                    </>
                );
            },
        },
        {
            id: 'delete',
            Header: 'Delete',
            accessor: company => <button
                onClick={() => {
                    setDeleteCompany(company)
                    dispatch(toggleModal({ open: 'deleteCompanyPopup' }))
                }
                }
                style={{ backgroundColor: "transparent" }}>
                <i data-tooltip="Delete Company" className="fa fa-trash c9 cp" style={{ fontSize: '20px' }} />
            </button>
        }
    ]);

    // Fetch data from server when table changes
    const fetchData = async (state) => {
        setLoading(true);

        try {
            // Build params from table state
            const params = {
                page: state.page + 1, // react-table pages are 0-index, backend is 1-index
                limit: state.pageSize,
                search: searchTerm || state.filtered?.[0]?.value || "", // Use searchTerm state
                sortField: state.sorted?.[0]?.id || "createdAt",
                sortOrder: state.sorted?.[0]?.asc ? "asc" : "desc",
            };

            const companiesResponse = await getRequest(
                `/company/getAllCompanies?page=${params.page}&limit=${params.limit}&search=${encodeURIComponent(
                    params.search
                )}&sortField=${params.sortField}&sortOrder=${params.sortOrder}&isArchived=${isArchived}&yopmailOnly=${isYopmail || false}`
            );

            if (companiesResponse && companiesResponse.code === 200) {
                const { allCompanies, pagination } = companiesResponse.body;
                setData(allCompanies || []);
                setPages(pagination?.totalPages || 0);
            } else {
                setData([]);
                setPages(0);
            }
        } catch (error) {
            console.error("Error fetching companies:", error);
            setData([]);
            setPages(0);
        }

        setLoading(false);
    };

    // Handle search input change
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    // Handle search submission
    const handleSearchSubmit = (e) => {
        e.preventDefault();
        fetchData({ page: 0, pageSize: 20, filtered: [], sorted: [] });
    };

    return (
        <>
            <div className="bg1 shadow p2rem dg gg2rem">
                <div className="df fdc aic bss bw2px bo5 br10px p2rem w100">
                    <h3 className="fs1-5rem fs2rem-sm ttu tac c4">
                        Subscribed Companies Database
                    </h3>

                    {/* Search Bar */}
                    <div className="w100 df jcc mt1rem">
                        <form onSubmit={handleSearchSubmit} className="df w100 maxw600px">
                            <div className="df w100" style={{ borderRadius: '12px', overflow: 'hidden' }}>
                                <input
                                    type="text"
                                    placeholder="Search companies by name, type, or stage..."
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    className="flex1 py1rem px1-5rem bss bw2px bo5"
                                    style={{ fontSize: '1rem', outline: 'none', backgroundColor: '#f8f9fa', transition: 'all 0.3s ease', width: '450px', borderRadius: '12px' }}
                                />
                            </div>
                        </form>
                    </div>

                    <div className="admin-table mt1rem w100 ttc tac">
                        <ReactTable
                            manual // server-side mode
                            data={data}
                            pages={pages}
                            loading={loading}
                            columns={companiesColumns}
                            defaultPageSize={20}
                            onFetchData={fetchData} // triggered on sort, filter, paginate
                            minRows={0} // don't show empty extra rows
                            className="-striped -highlight"
                        />
                    </div>
                </div>
            </div>
            <AdminCompanyDetailsModal id={selectedCompany?._id} setPlan={setPlan} />

            <SubscriptionPaymentConfirm
                plan={plan}
                defaultStep={plan === "Free" ? "freeMembership" : "subscriptionUpgrade"}
                company={selectedCompany}
                companyId={selectedCompany?._id}
                navigateTo={'AdminCompanyDetails'}
                onCancel={() => dispatch(toggleModal({ open: 'AdminCompanyDetails' }))}
            />
        </>
    );
};

export default SubscribedCompaniesTab;
